import { useMemo } from "react";

import { useEdoRouter } from "src/hooks/useEdoRouter";
import { useVercelFrontendConfig } from "src/hooks/useVercelFrontendConfig";
import {
  AnnouncementRule,
  getAnnouncementForPath,
} from "src/utility/announcements";

export function useAnnouncement(): AnnouncementRule | undefined {
  const router = useEdoRouter();
  const frontendConfig = useVercelFrontendConfig();

  return useMemo(() => {
    if (!frontendConfig) {
      return undefined;
    }
    return getAnnouncementForPath(router.pathname, frontendConfig);
  }, [router.pathname, frontendConfig]);
}
